exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-3f3e0e7e]{max-width:240px}.medical-courses-list .btn[data-v-3f3e0e7e]{font-size:.7rem;background:#98a6ad;border:none;cursor:default}.medical-courses-list .btn[data-v-3f3e0e7e]:focus{box-shadow:none}", ""]);

// exports
